import React, { useEffect, useState } from 'react';
import './splash-screen.scss';

interface SplashScreenProps {
  onComplete: () => void;
  gender?: 'male' | 'female' | null; // null = default splash, 'male'/'female' = specific splash
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete, gender = null }) => {
  const [isVisible, setIsVisible] = useState(true);

  // Determine which splash image to use
  const getSplashImage = () => {
    if (gender === 'male') {
      console.log('🖼️ [SPLASH] Showing male splash');
      return '/man-presenting.jpeg';
    } else if (gender === 'female') {
      console.log('🖼️ [SPLASH] Showing female splash');
      return '/woman-presenting.jpeg';
    } else {
      console.log('🖼️ [SPLASH] Showing default splash');
      return '/AmeenSplash.png'; // Default splash
    }
  };

  const splashImage = getSplashImage();
  
  console.log(`🖼️ [SPLASH] Rendering splash with gender: ${gender}, image: ${splashImage}`);

  useEffect(() => {
    console.log(`⏱️ [SPLASH] Starting ${gender ? gender + ' splash' : 'default splash'} timer (4s)`);
    // إخفاء SplashScreen بعد 4 ثوانٍ
    const timer = setTimeout(() => {
      console.log(`✅ [SPLASH] Timer complete for ${gender ? gender + ' splash' : 'default splash'}`);
      setIsVisible(false);
      // Call onComplete immediately without delay
      console.log(`🚀 [SPLASH] Calling onComplete for ${gender ? gender + ' splash' : 'default splash'}`);
      onComplete();
    }, 4000);

    return () => {
      console.log(`🧹 [SPLASH] Cleaning up timer for ${gender ? gender + ' splash' : 'default splash'}`);
      clearTimeout(timer);
    };
  }, [onComplete, gender]);

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className="splash-screen" 
      style={{ backgroundImage: `url(${splashImage})` }}
    >
      {/* الصورة كخلفية فقط */}
    </div>
  );
};

export default SplashScreen;
